import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const MobileAppDevelopmentPage: React.FC = () => {
  return <ServicePageTemplate slug="mobile-app-development" />;
};

export default MobileAppDevelopmentPage;
